/* eslint-disable */
declare var ga: any;

export const loadGoogleAnalytics = (token: string) => {
  if (typeof window !== 'undefined') {
    (function (i, s, o, g, r, a, m) {
      (i as any).GoogleAnalyticsObject = r;
      // @ts-ignore
      (i[r] =
        // @ts-ignore
        i[r] ||
        function () {
          // @ts-ignore
          (i[r].q = i[r].q || []).push(arguments);
        }),
        // @ts-ignore
        (i[r].l = 1 * <any>new Date());
      // @ts-ignore
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      // @ts-ignore
      a.async = 1;
      // @ts-ignore
      a.src = g;
      // @ts-ignore
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    ga('create', token, 'auto');
    ga('require', 'displayfeatures');
    ga('send', 'pageview');
  }
};
